{
 "clickScreen": {
  "1": "Klikkaa ruutua"
 },
 "mobileOrientation": {
  "1": "Käännä laitteesi vaakatasoon"
 },
 "tips": {
  "noTips": "Ei vihjeitä",
  "gameStarted": "Olet jäänyt ansaan. Päästäksesi ulos talosta, sinun on löydettävä bunkkeri, josta trolli tehtailee valeuutisia. Tutkimalla huoneita löydät vihjeitä, jotka auttavat sinua eteenpäin.",
  "matrixPoster": "Huomasitko sängyn yläpuolella oudon paperikasan? Käy tutkimassa sitä.",
  "solveMatrix": "Palaa paperikasan luo. Raahaa palaset oikeille paikoille katkoviivan sisään.",
  "goToTwitter": "Oletko jo tutkinut pöydällä olevaa tietokonetta?",
  "twitterPassword": "Tutki kokoamaasi palapeliä uudelleen. Onko trolli kirjoittanut siihen vihjeen?",
  "twitterExplained": "Jahtaamasi trolli kirjoittelee valeprofiilin takaa valheita sosiaaliseen mediaan. Tunnistamalla trollin pääset lähemmäs bunkkeria.",
  "lockConsole": "Käytävässä oven rautaoven oikealla puolella on mekaaninen lukko. Valitse se.",
  "solveLockConsole": "Näit tietokoneella kolme sosiaalisen median profiilia. Kuka heistä julkaisee virheellistä tietoa? Hänen profiilinimensä avulla saat oven lukon auki.",
  "magazine": "Trollin työpöydällä on jotain mielenkintoista.",
  "cameraLocker": "Trolli kuvaa salaa ihmisiä ja saattaa olla lehdessä näkyvän kuvan takana. Jonnekin tähän varastoon on piilotettu kamera. Huomasitko oven vieressä olevan kaapin?",
  "solveCameraLocker": "Kaapin saa auki koodilla. Ehkä voisit tutkia lehteä uudelleen.",
  "camera": "Tutki kameraa.",
  "solveClock1": "Lehdessä ja kamerassa oli yksi sama kuva. Lehteen lähetetystä kuvasta oli rajattu jotain pois. Se löytyy nyt täältä jostain.",
  "solveClock2": "Tutki kameran rullaa. Näkyikö siellä kelloa? Siirrä ovessa olevan kellon viisarit oikeaan aikaan.",
  "bunkerFound": "Olet löytänyt tiesi bunkkeriin, josta trolli lähettää valheita eri alustoille valeprofiilien takaa. Hänen tavoitteenaan on lietsoa sekasortoa. Työsi tutkivana toimittajana on kuitenkin vielä kesken, et ole vielä vapaa.",
  "controlPanel": "Näetkö lattialla johtoja? Mihin ne vievät?",
  "solveControlPanel1": "Miten johdot yhdistetään? Seuraa johtoja ja tarkkaile valoja.",
  "solveControlPanel2": "Palaa vielä sähkökaapille. Näitkö eri huoneissa sinisiä loisteputkia? Loisteputkien määrä kertoo, mihin reikään yhdistät kustakin huoneesta tulevan johdon.",
  "bunkerComputer": "Yhdistit johdot oikein. Pöydällä oleva näyttö meni päälle.",
  "solveBunkerComputer": "Palaa tietokoneelle. Kaikki netissä sanottu ei ole totta.",
  "bunkerComputerWrong": "Tutki tarkemmin tietokoneella olevia julkaisuja. Missä niistä on epäluotettavalta vaikuttava lähde tai kuva? Ilmianna se.",
  "warehouseComputer": "Kun bunkkerista ei pääse eteenpäin, on vain yksi suunta, mihin lähteä.",
  "solveWarehouseComputer": "Kuva ei aina kerro totuutta ja niillä voi johtaa harhaan.",
  "warehouseComputerWrong": "Tutki tietokoneella olevia julkaisuja ja erityisesti niiden kuvia. Kolmea niistä on käsitelty. Ilmianna ne.",
  "flatComputer": "Myös ensimmäisessä huoneessa taisi olla tietokone?",
  "solveFlatComputer": "Liian hyvää ollakseen totta? Poista turhat lupaukset.",
  "flatComputerWrong": "Palaa vielä tietokoneelle. Vain yksi viesteistä on oikea. Valitse huijausviestit klikkaamalla niiden edessä olevaa ruutua ja siirrä ne roskakoriin.",
  "safariPoster": "Sait sähköpostiisi uuden viestin. Löytyisikö siitä vihjettä etenemiseen?",
  "safariPoster2": "Tutki seinällä olevaa leijonajulistetta. Sen takana saattaa olla jotain."
 },
 "loading": {
  "1": "Ladataan 3D-mallia...",
  "2": "Ladattu",
  "3": "Vielä hetki... Käynnistetään peliä.",
  "4": "Ladataan kuvia...",
  "5": "Kaikki kuvat ladattu."
 },
 "start": {
  "1": "Astut sisään ja ovi sulkeutuu takanasi. Tajuat joutuneesi ansaan.",
  "2": "Olet tutkiva toimittaja. Sait vihjeen, että tässä autiotalossa sijaitsee trollitehdas, josta syydetään maailmalle valeuutisia.",
  "3": "Miten pääset ulos?",
  "4": "Eteenpäin",
  "5": "Voit tarttua esineisiin menemällä lähelle ja painamalla niitä.",
  "6a": "Liikkuminen",
  "6b": "Pyöriminen",
  "7a": "Saat kursorin näkymään painamalla",
  "7b": "-nappia",
  "8a": "ALOITA",
  "8b": "ETEENPÄIN"
 },
 "twitter": {
  "1": "Syötä salasana",
  "2": "Kirjaudu",
  "3": "Sulje",
  "4": "Pääsy estetty",
  "5": "Hyväksytty",
  "6": "Hetki...",
  "7": "Tervetuloa!",
  "Name1": "Minna",
  "Name2": "Olli Korhonen",
  "Name3": "jHg",
  "NickName1": "minna_banana",
  "NickName2": "OlliTheOrange",
  "NickName3": "Meloni_6745792",
  "Desc1": "Äiti, puoliso, koiraihminen, opettaja ja harrastelijapuutarhuri. Twiittaa suomeksi.",
  "Desc2": "Ensihoitaja, joka harrastaa luontoliikunta monessa muodossa: patikointia, suunnistusta ja geokätköilyä. Mukana usein myös jälkikasvua.",
  "Desc3": "",
  "Following": "Seurattua",
  "Followers": "Seuraajaa",
  "Follow": "Seuraa",
  "Joined": "Liittynyt",
  "Hashtag1": "rokotteet",
  "message1": "Suomessa kaikki viranomaiset suosittelevat ottamaan rokotteen. Mars matkaan! <span class=\"twitterHashtags\">#immuniteetti #terveys</span>",
  "message2": "Uskallatteko ottaa teidän lapsille influessarokotetta? Jos siitä tuleekin narkolepsiaa :( Toisaalta <span class=\"twitterHashtags\"><b>#rokotteet</b></span> kai pitäis ottaa. Pelottaa vähän.",
  "message3": "Nyt se on päätetty: meidän perheeseen tulee kuin tuleekin uusi iiiiihana koiranpentu. En kestä ❤️❤️❤️ <span class=\"twitterHashtags\">#koirakuume #inlove #perheenjäsen </span>",
  "message4": "Suomalaiset opettajat ovat huippuja - kaikesta paineesta huolimatta.",
  "message5": "Hakusessa järjestelmäkamera. Suosituksia? Hintaluokka max 1000 e ja käyttötarkoitus enimmäkseen luontokuvausta mutta toimittava myös fudiskentän laidalla :o)",
  "message6": "Virossa on ollut 3542 kuollutta ihmistä rokottamisessa! Mieti mitä roskaa he ruokkivat sinua! <span class=\"twitterHashtags\"><b>#rokotteet #influenssa #salaliitto</b></span> bit.ly/p/skdjKSDisjd...",
  "news": "UUTINEN",
  "tweetsTotal": "tweettiä",
  "newsHeader": "Riittävään vuorovaikutukseen ei ole tarpeeksi aikaa",
  "newsHeader2": "UUTINEN: Kiireettömät tapaukset kuormittavat ensihoitoa"
 },
 "infoScreen": {
  "game": "Trollibunkkeri on Yle Oppimisen laatima pakohuonepeli, jossa opitaan mediataitoja.",
  "header": "Tietoa pelistä",
  "closeWindow": "Sulje ikkuna",
  "Desktop": "Pääset liikkumaan talossa hiirellä ja nuolinäppäimillä tai kirjaimilla WASD. Voit tarttua esineisiin ja tarkastella niitä menemällä lähelle ja klikkaamalla niitä. Saat kursorin tarvittaessa näkymään Esc-napilla.",
  "Mobile": "Mobiililaitteilla liikkuminen tapahtuu pyörittämällä näkyviä ohjainkiekkoja. Voit tarttua esineisiin ja tarkastella niitä menemällä lähelle ja painamalla niitä.",
  "feedback": "Olemme iloisia kaikesta saamastamme palautteesta. Sitä voi lähettää osoitteeseen <a href=\"mailto:oppiminen.palaute@yle.fi\">oppiminen.palaute@yle.fi</a>.",
  "creditsHeader": "Tekijätyöryhmä"
 },
 "facebook": {
  "messageHeader": "Suhtaudumme vakavasti valeuutisiin. Kiitos, että autat meitä!",
  "message": "Voit ilmiantaa vain yhden näistä kolmesta uutisesta epäilyttäväksi. Valintasi on",
  "confirm_button": "Ilmianna",
  "cancel_button": "Peruuta",
  "cta_button": "Ilmiannettu",
  "cta_pressed_button": "Ilmianna uutinen",
  "posts": {
   "first": {
    "name": "Solvi Saikkonen",
    "message": "Ahneita lintuja!",
    "linkUrl": "yle.fi",
    "linkHeader": "Outo riesa lypsykarjatiloilla: Talitintit nokkivat lehmien utareita",
    "linkDesc": "Etelä-Lapin Simossa on talven aikana törmätty outoon linturiesaan: Navettaan sisälle päässeet talitiaiset (Parus major) ovat nokkineet lehmien utareet avohaavoille, niin että lehmiä on jouduttu tautien vuoksi jopa lopettamaan. Asiasta uutisoi ensin Maaseudun Tulevaisuus. Lehden mukaan Lapista tapauksia tiedetään kolme."
   },
   "second": {
    "name": "Seppo Äs",
    "message": "\"Aika hurjia uutisia Venetsiasta!",
    "linkUrl": "kappasvaan.com",
    "linkHeader": "Venetsiassa luistellaan nyt kanaaleilla!\",",
    "linkDesc": "Nopeasti etenevä ilmastonmuutos tuottaa poikkeuksellisia sääilmiöitä myös Euroopassa. Venetsialaisia kohtasi hämmästyttävä näky, kun he heräsivät tiistaiaamuna: kaupungin kuuluisat kanaalit olivat umpijäässä. Koska gondoliliikenne oli jumissa, kaupunkilaiset eivät päässeet työpaikoilleen. Moni käyttikin ylimääräisen vapaapäivän luistelemalla kanaaleja pitkin."
   },
   "third": {
    "name": "Taru Aapkari",
    "message": "Uskallatko enää hymyillä?",
    "linkUrl": "hs.fi",
    "linkHeader": "Hampaiden juurten vuosirenkaat kertovat elämämme käännekohdista",
    "linkDesc": "Hampaisiin, tarkemmin sanottuna sen hammassementtiin, on kirjautunut tietoa siitä, milloin nainen synnytti tai milloin vaihdevuodet alkoivat. Hammassementin pinnassa näkyvät myös pitkäkestoinen stressi ja jopa kuluneet vuodet vankilassa, jos niin ikävästi käy elämässä. Koettelemukset näkyvät juuren pinnassa hammassementin vaaleuden eroina, vähän kuin puun kasvun vuodet sen vuosirenkaissa."
   }
  }
 },
 "framegram": {
  "message": "Hyvä käyttäjä, meille sisällön todenmukaisuus on tärkeää. Toivomme, että ilmimannat meille epäluotettavina pitämäsi julkaisut.",
  "ok": "ok",
  "reported": "Ilmiannettu",
  "kpl": "kpl",
  "posts": {
   "first": {
    "name": "KimaS",
    "message": "Pitkästä aikaa täällä! Ja kulkikin ihan hyvin. Kantsis varmaan useammin teloa jalkansa :D #salilekasalilvika <b>#instasports #martialarts</b>"
   },
   "second": {
    "name": "pave_xe",
    "message": "Löysin mun uuden lempiprotskun nimeltä Äijä-Vita Pro! Sitä vetämällä ja säännöllisellä meditoinnilla mun haba on kasvanu ihan huikeesti! <b>#haba #lisäravinteet</b>"
   },
   "third": {
    "name": "matsmek",
    "message": "Me kierrettiin Mimin kanssa tänään tooosi pitkä lenkki ja nyt aletaan laittaan ruokaa. Ihanaa lauantai-iltaa kaikille   &lt;3 <b>#lenkki #koiralenkki #lauantai #weekend #dog #dogsofinstagram #doglovers #doglife #bae #koiruli #nature #sports #mimi #saturday</b>"
   },
   "fourth": {
    "name": "gmeyrham",
    "message": "Levittäkää sanaa! Paraurheilija X lautailee vain yhdellä jalalla. Viime viikolla hän menetti viimeisen sponsorinsa ja nyt hänellä ei ole rahaa matkustaa kisoihin Alpeille. Auttakaa häntä pienellä lahjoituksella tilille CE11435-23595"
   },
   "fifth": {
    "name": "llizzy_loe",
    "message": "Mä voisin niin muuttaa tänne! Nukkua lattialla ja fiilisellä näitä AARTEITA.🎶 ❤ 🎧 🎶<b>#lovemusic #instamusic #levykauppa</b>"
   },
   "sixth": {
    "name": "li4lah",
    "message": "Kiitti kaikille, jotka tuli kuuntelee meitä! Keikka oli ihan loppuunmyyty ja paikka ihan täynnä!"
   },
   "seventh": {
    "name": "a.m.o.n.e.",
    "message": "🌴 ☀ 🍹 🌴 <b>#instatravel #vacation #holidaymood</b>"
   }
  },
  "likes": "tykkäystä",
  "report": "Ilmianna"
 },
 "email": {
  "notification": {
   "header": "Sinulle on uusi sähköposti",
   "source": "Julistekauppa.net",
   "address": "asiakaspalvelu@julistekauppa.net",
   "text": "Arvioi tuotteesi"
  },
  "error": "Järjestelmävirhe! Valitse viisi viestiä.",
  "moveToTrash": "Siirrä valitut roskakoriin",
  "cancelAction": "Palauta sähköpostit",
  "title6": "Risk Free",
  "title5": "Bonus 500e",
  "title4": "Huonot uutisia",
  "title3": "Lisätoimi",
  "title2": "Tilauksesi on postitettu",
  "title1": "Lahjoitustasi",
  "shopName": "Kiikarikauppa.com",
  "shopAddress": "asiakaspalvelu@kiikarikauppa.com",
  "mail1": {
   "1": "Nimeni on Marc B. Jackson Jr. ja voitin 344,6 miljoonaa dollaria Powerball-jattipotin 4. kesakuuta 2020.",
   "2": "Lahjoitan viidelle satunnaisesti valitulle sahkopostiviestille, ja sinun omasi on yksi sahkopostiosoite, jotka olen valinnut arvontaan. Lahjoitan 1 000 000 euroa sinulle ja perheellesi vilpittomassa mielessa.",
   "3": "Ota yhteytta sahkopostitse <b><u>marcjacksonjr85@bmail.com</u></b> pyytaaksesi lahjoitustasi."
  },
  "mail2": {
   "1": "Hyvä asiakas,",
   "2": "Kiikarikauppa.com tilauksesi on nyt postitettu lähetystunnuksella <b>JJFI6147051898801</b>. Voit seurata tilaustasi Postin sivuilta.",
   "3": "Tilasit 1 x \"Powerpro-2 8/20-kiikarin\".",
   "4": "Jos tilauksessasi on jotain ongelmaa niin vastaa tähän viestiin.",
   "5": "Ystävällisin terveisin,<br/> Asiakaspalvelu<br/><b>Kiikarikauppa.com</b>"
  },
  "mail3": {
   "1": "Hyvä asiakas,",
   "2": "Pahoittelemme ilmoittaa sinulle, että pakettisi toimittaminen epäonnistui.<br /> Pakettisi käyttö edellyttää nyt lisätoimenpiteitä.",
   "3": "Seurantanumero"
  },
  "mail4": {
   "1": "Hei,",
   "2": "Minulla on huonoja uutisia sinulle!<br /> Hakkeroin käyttöjärjestelmäsi minulla on pääsy tekstiviesteihisi, sähköposteihisi ja kuviisi, jotka haluan jakaa yhteystietojesi (ystävien, sukulaisten ja työtovereiden kanssa) pilaamaan maineesi. Olen tallentanut sinut lukemattomia kertoja verkkokamerasi kautta ja kuunnellut keskustelujasi verkkokamerallasi.",
   "3": "Voin saada sinut menettämään ystäväsi, kollegasi ja työpaikkasi.",
   "4": "KLIKKAA"
  },
  "mail5": {
   "1": "Onnittelu,<br /> Meillä on ilo ilmoittaa, että olet yksi harvoista valituista, jotka saavat ainutlaatuisen tilaisuuden napata tämän tarjouksen: 500€ BONUS!",
   "2": "Älä ohita tilaisuuttasi!",
   "3": "KLIKKAA"
  },
  "mail6": {
   "1": "I am very sorry in reaching out to you without a consent proper authorization, but I think it's wise for me to share  with you a business proposal of $18M about your last name for an investment transaction which is 100% risk free if interested please reply my email: <b><u>kufo.1217@bmail.com</u></b>"
  },
  "newMail1": "Hyvä asiakas,",
  "newMail2": "Arvioi tuotteesi ja voita lahjakortti.",
  "newMail3": "Tilasit 1 x \"Retro savanni -juliste\".",
  "newMail4": "Ystävällisin terveisin,<br />Asiakaspalvelu<br /> <b>Julistekauppa.net</b>"
 },
 "endingScreen": {
  "title": "Mahtavaa!",
  "timeSpent": "Selvisit trollibunkkerista ulos ajassa",
  "linkText": "Lue lisää valeuutisten tunnistamisesta",
  "link": "<a href=\"https://yle.fi/valheenpaljastaja\">https://yle.fi/valheenpaljastaja</a>",
  "recommend": "Suosittele kavereille",
  "shareText": "Pääsin pakoon trollin bunkkerista. Pääsetkö sinä?"
 },
 "landingPage": {
  "openInBrowser": "Avaa peli selaimessa",
  "link": "link.yle.fi/trollibunkkeri",
  "copied": "Kopioitu"
 }
}